// Traductions page publique Détaillant — FR / EN / ES / Créole / Arabe (ton marketing)
export const CONCEPT_I18N = {
  ar: {
    popsBadge: 'كن POP\'S — شريك عروض المنتجات التضامنية',
    popsDef: 'تُسمّى المتاجر بالتجزئة في القاعة POP\'S: شريك عروض المنتجات التضامنية، بائع مؤقت في قاعة COOP\'ACT.',
    topShops: 'قائمة أفضل متاجر POP\'S تقييمًا',
    topShopsSub: 'المتاجر المفضلة لدى المشتركين — تُقيَّم بعد كل استلام.',
    replyLabel: 'رد المتجر:',
    videoTitle: 'منتجاتك تستحق القاعة — شاهد كيف تنبض عروضك بالحياة',
    tag: "KDMARCHÉ × O'SCOP — مساحة متاجر التجزئة",
    h1a: 'مخزونك غير المُباع له قيمة.',
    h1b: "حوّله إلى مبيعات على COOP'ACT",
    sub: "مخزون راكد؟ تواريخ صلاحية تقترب؟ نهايات تشكيلات؟ لا تُصفِّ بخسارة، بل شارك في Coop'Act! انضم إلى أول بورصة تعاونية بسعر تنازلي: عروضك ×3 تجد مشترين خلال ساعات لدى مجتمع ملتزم، بالسعر العادل، في أي مكان بالعالم. صفر تفاوض، صفر خسارة: أنت تحدد التخفيض والقاعة تتكفل بالباقي.",
    cta: 'أطلق متجري — 390 €/شهر',
    cta2: 'شاهد القاعة أثناء العمل',
    how: 'أول عملية بيع لك في 5 خطوات',
    share: 'شاركها مع متجر يستحق البيع بشكل أفضل:',
    shareMsg: "أيها المتجر الصديق 👋 مخزونك غير المُباع يساوي ذهبًا في بورصة COOP'ACT من KDMARCHÉ × O'SCOP. أودِع عروضك والقاعة تبيع نيابةً عنك!",
    catalogTitle: "كتالوج POP'S LOLODRIVE — الساري حاليًا",
    catalogSub: 'المنتجات التي يمكنك إيداعها في القاعة اعتبارًا من اليوم، منتقاة ومحدَّثة من فريقنا.',
    perishable: 'قابل للتلف — صلاحية 3 أشهر كحد أدنى',
    demoTag: 'عرض تفاعلي — جرّب القاعة',
    demoTitle: 'عِش انخفاض السعر مباشرةً',
    demoSub: "كل Coop'Act يخفض السعر — أول من يقبل يفوز بالعرض.",
    demoBid: "شارك في Coop'Act",
    demoWon: "بيع! أول مشترك في Coop'Act يفوز بالعرض",
    demoReset: 'أعد تشغيل العرض',
    demoValue: 'قيمة المتجر',
    demoEach: "كل نقرة = Coop'Act",
    demoFloor: 'حد أدنى −15 %',
    demoTime: 'ينتهي البيع خلال',
    demoLiveTag: "مباشر من قاعة COOP'ACT",
    demoLiveCta: "شارك في هذا العرض في القاعة",
    demoLiveBids: "{{count}} Coop'Act حتى الآن",
    demoLiveOff: 'أي −{{pct}} % مقابل قيمة المتجر',
    demoLiveEnd: 'ينتهي خلال',
    features: [
      ['واجهتك العالمية مفتوحة 24/7', "البورصة التعاونية بسعر تنازلي تعمل لصالحك: كل دقيقة يتحرك السعر ويجذب المشتركين. أول من يقبل، يشتري. مخزونك يتحرك وسيولتك تتنفس."],
      ['3 عروض مجانية كل شهر', 'اشتراكك 390 €/شهر يشمل 3 إيداعات للعروض — لتصريف فائضك دون رسوم خفية. دون رسوم خفية.'],
      ['تحتفظ بالسيطرة على أسعارك', 'حدد سعر متجرك، واختر تخفيضك (ابتداءً من −15 %) بنسبة أو مبلغ. شفافية كاملة: السعر النهائي يظهر قبل التأكيد.'],
      ['من بوانت-آ-بيتر إلى بانكوك', 'علم بلدك، واسمك التجاري في المقدمة، وواجهة بـ 5 لغات (عربي/فرنسي/إنجليزي/إسباني/كريولي): متجرك يتجاوز شارعك بكثير.'],
      ['العد التنازلي الذي يخلق الرغبة', 'برمج مبيعاتك في اللحظة المثالية: العد التنازلي المعروض في القاعة يحوّل الانتظار إلى رغبة في الشراء. عروضك تُباع أسرع وبسعر أعلى.'],
      ['تسليم مباشر، صفر نزاع', 'كل فائز يعرض رمز QR الفريد الخاص به خلال فترات الاستلام. تسليم موثّق ومؤكد وآمن — تبيع وبالك مرتاح.'],
    ],
    steps: [
      'أنشئ واجهتك في 3 دقائق: الاسم التجاري، المدينة، البلد وفترات الاستلام.',
      'فعّل اشتراك متاجر التجزئة (390 €/شهر): دخول القاعة + 3 عروض مجانية كل شهر.',
      'اختر من كتالوج LOLODRIVE الساري، كوّن عرضك ×3، أضف صورك وحدد تخفيضك (ابتداءً من −15 %).',
      "أودِع عرضك بنقاط COOP'ACT — تُسترد نقاطك إذا رُفض العرض.",
      'اعتماد سريع من فريقنا، عد تنازلي في القاعة… والفائز يستلم عرضه برمز QR. بيعت!',
    ],
  },
  fr: {
    popsBadge: "Devenez un POP'S — Partenaire d'Offres de Produits Solidaires",
    popsDef: "Les boutiques détaillantes de la salle sont appelées POP'S : Partenaire d'Offres de Produits Solidaires, vendeur éphémère en salle COOP'ACT.",
    topShops: "Palmarès des POP'S les mieux notés",
    topShopsSub: 'Les boutiques préférées des Coop\'acteurs — notées après chaque enlèvement.',
    replyLabel: 'Réponse de la boutique :',
    videoTitle: 'Vos produits méritent la salle — regardez comment vos lots prennent vie',
    tag: "KDMARCHÉ × O'SCOP — Espace Détaillant",
    h1a: 'Vos invendus ont de la valeur.',
    h1b: "Transformez-les en ventes sur COOP'ACT",
    sub: "Stock qui dort, DLC qui approchent, fins de série ? Ne bradez plus, coop'actez ! Rejoignez la première Bourse Coopérative à prix descendant : vos lots ×3 trouvent preneur en quelques heures auprès d'une communauté de Coop'acteurs engagés, au juste prix, partout dans le monde. Zéro négociation, zéro perte sèche : vous fixez la réduction, la salle fait le reste.",
    cta: 'Je lance ma boutique — 390 €/mois',
    cta2: 'Voir la salle en action',
    how: 'Votre première vente en 5 étapes',
    share: 'Faites tourner à une boutique qui mérite de vendre mieux :',
    shareMsg: "Boutique amie 👋 Tes invendus valent de l'or sur la Bourse COOP'ACT de KDMARCHÉ × O'SCOP. Dépose tes lots, la salle vend pour toi !",
    catalogTitle: "Catalogue POP'S LOLODRIVE — en vigueur",
    catalogSub: "Les produits que vous pouvez déposer dès aujourd'hui en salle, sélectionnés et mis à jour par notre équipe.",
    perishable: 'Périssable — DLC min. 3 mois',
    demoTag: 'Démo interactive — essayez la salle',
    demoTitle: 'Vivez une descente de prix en direct',
    demoSub: "Chaque Coop'Act fait baisser le prix — le premier qui accepte remporte le lot.",
    demoBid: "Coop'acter",
    demoWon: 'VENDU ! Le premier Coop\'acteur remporte le lot',
    demoReset: 'Rejouer la démo',
    demoValue: 'Valeur boutique',
    demoEach: "chaque clic = un Coop'Act",
    demoFloor: 'plancher −15 %',
    demoTime: 'fin de la vente dans',
    demoLiveTag: "En direct de la salle COOP'ACT",
    demoLiveCta: "Coop'acter ce lot en salle",
    demoLiveBids: "{{count}} Coop'Act déjà placés",
    demoLiveOff: 'soit −{{pct}} % vs valeur boutique',
    demoLiveEnd: 'se termine dans',
    features: [
      ['Votre vitrine mondiale, ouverte 24h/24', "La Bourse Coopérative à prix descendant travaille pour vous : chaque minute, le prix bouge et attire les Coop'acteurs. Le premier qui accepte, achète. Vos invendus repartent, votre trésorerie respire."],
      ['3 offres offertes chaque mois', "Votre abonnement 390 €/mois inclut 3 dépôts de lots — de quoi écouler vos surplus sans frais cachés."],
      ['Vous gardez la main sur vos prix', 'Fixez votre prix boutique, choisissez votre remise (dès −15 %), en % ou en montant. Transparence totale : le prix final s\'affiche avant de valider.'],
      ['De Pointe-à-Pitre à Bangkok', 'Drapeau de votre pays, raison sociale mise en avant, interface en 4 langues (FR/EN/ES/Créole) : votre boutique rayonne bien au-delà de votre rue.'],
      ['Le countdown qui crée l\'envie', "Programmez vos ventes au meilleur moment : le compte à rebours affiché en salle transforme l'attente en désir d'achat. Vos lots partent plus vite, plus haut."],
      ['Remise en main propre, zéro litige', "Chaque gagnant présente son QR unique dans vos créneaux d'enlèvement. Remise tracée, confirmée, sécurisée — vous vendez l'esprit tranquille."],
    ],
    steps: [
      'Créez votre vitrine en 3 minutes : raison sociale, localité, pays et créneaux d\'enlèvement.',
      "Activez l'abonnement Détaillant (390 €/mois) : accès salle + 3 offres de lots offertes chaque mois.",
      'Piochez dans le catalogue LOLODRIVE en vigueur, composez votre lot ×3, ajoutez vos photos et fixez votre remise (dès −15 %).',
      "Déposez votre lot en crédits COOP'ACT — vos crédits sont remboursés si l'offre est refusée.",
      'Validation express par notre équipe, countdown en salle… et le gagnant vient chercher son lot avec son QR. Vendu !',
    ],
  },
  en: {
    popsBadge: "Become a POP'S — Solidarity Products Offer Partner",
    popsDef: "The room's retail shops are called POP'S: Solidarity Products Offer Partner, pop-up sellers in the COOP'ACT room.",
    topShops: 'Top-rated POP\'S leaderboard',
    topShopsSub: "The Coop'actors' favourite shops — rated after every pickup.",
    replyLabel: 'Shop reply:',
    videoTitle: 'Your products deserve the room — see how your lots come to life',
    tag: "KDMARCHÉ × O'SCOP — Retailer Space",
    h1a: 'Your unsold stock is worth money.',
    h1b: "Turn it into sales on COOP'ACT",
    sub: "Sleeping stock, approaching expiry dates, end-of-line items? Stop discounting blindly — coop'act! Join the first descending-price Cooperative Exchange: your ×3 lots find buyers within hours from a committed community of Coop'actors, at a fair price, worldwide. No haggling, no dead loss: you set the discount, the room does the rest.",
    cta: 'Launch my store — €390/month',
    cta2: 'See the room in action',
    how: 'Your first sale in 5 steps',
    share: 'Pass it on to a store that deserves to sell better:',
    shareMsg: "Hey fellow store 👋 Your unsold stock is gold on the KDMARCHÉ × O'SCOP COOP'ACT Exchange. Drop your lots, the room sells for you!",
    catalogTitle: "LOLODRIVE POP'S Catalog — currently in force",
    catalogSub: 'The products you can submit to the room today, curated and updated by our team.',
    perishable: 'Perishable — min. 3-month expiry',
    demoTag: 'Interactive demo — try the room',
    demoTitle: 'Experience a live price drop',
    demoSub: "Every Coop'Act lowers the price — first to accept wins the lot.",
    demoBid: "Coop'act",
    demoWon: 'SOLD! The first Coop\'actor wins the lot',
    demoReset: 'Replay the demo',
    demoValue: 'Store value',
    demoEach: "each click = one Coop'Act",
    demoFloor: '−15% floor',
    demoTime: 'sale ends in',
    demoLiveTag: "Live from the COOP'ACT room",
    demoLiveCta: "Coop'act this lot in the room",
    demoLiveBids: '{{count}} Coop\'Acts already placed',
    demoLiveOff: '−{{pct}}% vs store value',
    demoLiveEnd: 'ends in',
    features: [
      ['Your worldwide storefront, open 24/7', "The descending-price Cooperative Exchange works for you: every minute the price moves and draws Coop'actors in. First to accept, buys. Your unsold stock moves out, your cash flow breathes."],
      ['3 free offers every month', 'Your €390/month subscription includes 3 lot submissions — enough to clear your surplus with no hidden fees. No hidden fees beyond the subscription.'],
      ['You stay in control of your prices', 'Set your store price, choose your discount (from −15%), in % or amount. Full transparency: the final price shows before you confirm.'],
      ['From Pointe-à-Pitre to Bangkok', 'Your country flag, your store name up front, a 4-language interface (FR/EN/ES/Creole): your store shines far beyond your street.'],
      ['The countdown that builds desire', 'Schedule your sales for the perfect moment: the countdown displayed in the room turns waiting into buying urge. Your lots sell faster, higher.'],
      ['Hand-to-hand delivery, zero disputes', 'Every winner shows their unique QR during your pickup slots. Traced, confirmed, secured handover — you sell with peace of mind.'],
    ],
    steps: [
      'Create your storefront in 3 minutes: company name, locality, country and pickup slots.',
      'Activate the Retailer subscription (€390/month): room access + 3 free lot offers every month.',
      'Pick from the current LOLODRIVE catalog, build your ×3 lot, add your photos and set your discount (from −15%).',
      "Submit your lot in COOP'ACT credits — refunded if the offer is declined.",
      'Express review by our team, countdown in the room… and the winner collects the lot with their QR. Sold!',
    ],
  },
  es: {
    popsBadge: "Conviértase en POP'S — Socio de Ofertas de Productos Solidarios",
    popsDef: "Las tiendas minoristas de la sala se llaman POP'S: Socio de Ofertas de Productos Solidarios, vendedores efímeros en la sala COOP'ACT.",
    topShops: 'Ranking de los POP\'S mejor valorados',
    topShopsSub: "Las tiendas favoritas de los Coop'actores — valoradas tras cada retiro.",
    replyLabel: 'Respuesta de la tienda:',
    videoTitle: 'Sus productos merecen la sala — vea cómo sus lotes cobran vida',
    tag: "KDMARCHÉ × O'SCOP — Espacio Minorista",
    h1a: 'Sus excedentes valen dinero.',
    h1b: "Conviértalos en ventas en COOP'ACT",
    sub: "¿Stock dormido, fechas de caducidad cercanas, fines de serie? ¡No malvenda más, coop'acte! Únase a la primera Bolsa Cooperativa de precio descendente: sus lotes ×3 encuentran comprador en horas entre una comunidad de Coop'actores comprometidos, a precio justo, en todo el mundo. Sin regateos, sin pérdidas: usted fija el descuento, la sala hace el resto.",
    cta: 'Lanzo mi tienda — 390 €/mes',
    cta2: 'Ver la sala en acción',
    how: 'Su primera venta en 5 pasos',
    share: 'Compártalo con una tienda que merece vender mejor:',
    shareMsg: "Tienda amiga 👋 Tus excedentes valen oro en la Bolsa COOP'ACT de KDMARCHÉ × O'SCOP. ¡Deposita tus lotes, la sala vende por ti!",
    catalogTitle: "Catálogo POP'S LOLODRIVE — vigente",
    catalogSub: 'Los productos que puede depositar hoy mismo en la sala, seleccionados y actualizados por nuestro equipo.',
    perishable: 'Perecedero — caducidad mín. 3 meses',
    demoTag: 'Demo interactiva — pruebe la sala',
    demoTitle: 'Viva una bajada de precio en directo',
    demoSub: "Cada Coop'Act baja el precio — el primero que acepta gana el lote.",
    demoBid: "Coop'actar",
    demoWon: '¡VENDIDO! El primer Coop\'actor gana el lote',
    demoReset: 'Repetir la demo',
    demoValue: 'Valor en tienda',
    demoEach: "cada clic = un Coop'Act",
    demoFloor: 'suelo −15 %',
    demoTime: 'la venta termina en',
    demoLiveTag: 'En directo de la sala COOP\'ACT',
    demoLiveCta: 'Coop\'acte este lote en la sala',
    demoLiveBids: '{{count}} Coop\'Acts ya realizados',
    demoLiveOff: '−{{pct}} % vs valor en tienda',
    demoLiveEnd: 'termina en',
    features: [
      ['Su escaparate mundial, abierto 24/7', "La Bolsa Cooperativa de precio descendente trabaja para usted: cada minuto el precio se mueve y atrae a los Coop'actores. El primero que acepta, compra. Sus excedentes salen, su tesorería respira."],
      ['3 ofertas gratis cada mes', 'Su suscripción de 390 €/mes incluye 3 depósitos de lotes — suficiente para liquidar sus excedentes sin costes ocultos. Sin costes ocultos.'],
      ['Usted controla sus precios', 'Fije su precio de tienda, elija su descuento (desde −15%), en % o importe. Transparencia total: el precio final se muestra antes de confirmar.'],
      ['De Pointe-à-Pitre a Bangkok', 'La bandera de su país, su razón social destacada, interfaz en 4 idiomas (FR/EN/ES/Criollo): su tienda brilla mucho más allá de su calle.'],
      ['El countdown que despierta el deseo', 'Programe sus ventas en el mejor momento: la cuenta atrás en la sala convierte la espera en ganas de comprar. Sus lotes se venden más rápido y mejor.'],
      ['Entrega en mano, cero litigios', 'Cada ganador presenta su QR único en sus franjas de retiro. Entrega trazada, confirmada y segura — usted vende con tranquilidad.'],
    ],
    steps: [
      'Cree su escaparate en 3 minutos: razón social, localidad, país y franjas de retiro.',
      'Active la suscripción Minorista (390 €/mes): acceso a la sala + 3 ofertas de lotes gratis cada mes.',
      'Elija del catálogo LOLODRIVE vigente, componga su lote ×3, añada sus fotos y fije su descuento (desde −15%).',
      "Deposite su lote en créditos COOP'ACT — reembolsados si la oferta es rechazada.",
      'Validación exprés por nuestro equipo, countdown en la sala… y el ganador recoge su lote con su QR. ¡Vendido!',
    ],
  },
  gcf: {
    popsBadge: "Vin on POP'S — Patnè Òf Pwodui Solidè",
    popsDef: "Boutik détayan a sal la ka rélé POP'S : Patnè Òf Pwodui Solidè, vandè éfémè an sal COOP'ACT.",
    topShops: 'Palmarès a POP\'S ki pi byen noté',
    topShopsSub: "Boutik Coop'actè yo pi enmé — noté apré chak ranmasé.",
    replyLabel: 'Répons a boutik la :',
    videoTitle: 'Pwodui a-w mérité sal la — gadé kijan lo a-w ka pran vi',
    tag: "KDMARCHÉ × O'SCOP — Espas Détayan",
    h1a: 'Sa ou pa vann ni valè.',
    h1b: "Fè'y vin lajan asi COOP'ACT",
    sub: "Stok ka dòmi, DLC ka pwoché, fen a séri ? Pa vann a pèt ankò, coop'acté ! Antré an prèmyé Bous Koopérativ la a pri ka désann : lo ×3 a-w ka trouvé achtè an dé twa lè, adan on kominoté Coop'actè angajé, a jis pri, toupatou asi latè. Pon négosyasyon, pon pèt : ou ka mèt rédiksyon a-w, sal la ka fè rès la.",
    cta: 'An ka lansé boutik an mwen — 390 €/mwa',
    cta2: 'Gadé sal la ka maché',
    how: 'Prèmyé vant a-w an 5 étap',
    share: "Fè'y touné ba on boutik ki mérité vann pi byen :",
    shareMsg: "Boutik zanmi 👋 Sa ou pa vann ka vo lò asi Bous COOP'ACT a KDMARCHÉ × O'SCOP. Dépozé lo a-w, sal la ka vann ba-w !",
    catalogTitle: "Katalog POP'S LOLODRIVE — an vigè",
    catalogSub: 'Pwodui ou pé dépozé jòdi-la an sal la, chwazi é mété a jou pa ékip an nou.',
    perishable: 'Périsab — DLC min. 3 mwa',
    demoTag: 'Démo entèaktif — eséyé sal la',
    demoTitle: 'Gadé on pri ka désann an dirèk',
    demoSub: "Chak Coop'Act ka fè pri-a désann — prèmyé ki aksèpté ka genyen lo-a.",
    demoBid: "Coop'acté",
    demoWon: 'VANDI ! Prèmyé Coop\'actè-a ka genyen lo-a',
    demoReset: 'Rijwé démo-a',
    demoValue: 'Valè boutik',
    demoEach: "chak klik = on Coop'Act",
    demoFloor: 'planché −15 %',
    demoTime: 'vant la ka fini adan',
    demoLiveTag: "An dirèk dépi sal COOP'ACT la",
    demoLiveCta: "Coop'acté lo sala an sal la",
    demoLiveBids: "{{count}} Coop'Act déja fèt",
    demoLiveOff: '−{{pct}} % kont valè boutik',
    demoLiveEnd: 'ka fini adan',
    features: [
      ['Vitrin mondyal a-w, ouvè 24/24', "Bous Koopérativ la a pri ka désann ka travay ba-w : chak minit, pri-a ka bougé é ka atiré Coop'actè yo. Prèmyé ki aksèpté, ka achté. Stok a-w ka pati, kès a-w ka respiré."],
      ['3 òf gratis chak mwa', 'Abònman 390 €/mwa a-w ka enkli 3 dépo lo — asé pou vann sa ou ni an plis san fré kaché. San fré kaché.'],
      ['Ou ka rété mèt a pri a-w', 'Mèt pri boutik a-w, chwazi rédiksyon a-w (dépi −15 %), an % oben an lajan. Transparans total : pri final ka afiché avan ou validé.'],
      ['Dépi Lapwent jis Bangkok', 'Drapo a péyi a-w, non a boutik la douvan, entèfas an 4 lang (FR/EN/ES/Kréyòl) : boutik a-w ka kléré pi lwen ki lari a-w.'],
      ['Countdown la ka fè moun anvi', 'Pwogramé vant a-w a bon moman : kont a rebou an sal la ka fè moun anvi achté. Lo a-w ka pati pi vit, pi wo.'],
      ['Remiz an men, pon poblèm', 'Chak gayan ka montré QR a-y adan kréno a-w. Remiz trasé, konfirmé, sékirizé — ou ka vann trankil.'],
    ],
    steps: [
      'Kréyé vitrin a-w an 3 minit : non, vil, péyi é kréno ranmasé.',
      'Aktivé abònman Détayan (390 €/mwa) : aksè a sal la + 3 òf lo gratis chak mwa.',
      'Chwazi an katalog LOLODRIVE la, fè lo ×3 a-w, mèt foto a-w é chwazi rédiksyon a-w (dépi −15 %).',
      "Dépozé lo a-w an krédi COOP'ACT — yo ka rann vou si òf la refizé.",
      'Validasyon rapid pa ékip an nou, countdown an sal la… é gayan an ka vin pran lo-a èvè QR a-y. Vandi !',
    ],
  },
};
